import { QueryClient } from '@tanstack/react-query';

/**
 * A module-level singleton rather than something built inside App() — useAuth()
 * (invoked via useAuthBootstrap() at the very top of App(), before its own
 * <QueryClientProvider> has mounted) needs to invalidate queries on login/logout,
 * and calling the useQueryClient() hook there throws ("No QueryClient set") since
 * that call happens outside the provider's render tree. Importing this same
 * instance directly sidesteps the hook's context requirement entirely.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});
